import React, { Fragment } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { Avatar } from '@material-ui/core';
import {
  Table,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  TableHead,
  Typography,
  Paper,
  Link,
  Tooltip
} from '@material-ui/core';
import settings from '../../../utils/settings';
// import Normal from '../Icons/normal';
import Warning from '../Icons/warning';
import Icons from '../Icons';
import Loader from '../../../components/Loader';
import I18n from '../../../config/locales';
import { get, isEqual } from '../../../utils/lodash';
import { getExpiryOfLead } from '../../../containers/LeadManagement/helper';
import { getPlatformBasedUrl } from '../../../config/platformBasedUrls/url';
import { getToken } from '../../../utils/helper';
import feature from '../../../utils/feature';

const useStyles = makeStyles(theme => ({
  root: {
    border: 'none',
    marginTop: theme.spacing(1)
  },
  header: {
    backgroundColor: '#335977'
  },
  headerText: {
    color: '#FFE785',
    textTransform: 'uppercase',
    fontSize: 13,
    fontWeight: 'bold',
    padding: theme.spacing(1.5),
    backgroundColor: '#335977'
  },
  tableBody: {
    maxHeight: theme.spacing(27),
    overflow: 'scroll'
  },
  tableRow: {
    padding: theme.spacing(1.5)
  },
  tableCell: {
    width: 'auto',
    minWidth: theme.spacing(12.5),
    maxWidth: theme.spacing(12.5),
    padding: theme.spacing(1.5),
    color: '#4B4B4B',
    fontSize: 12,
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden'
  },
  statusTableCell: {
    minWidth: theme.spacing(20),
    maxWidth: theme.spacing(20)
  },
  linkTableCell: {
    color: theme.palette.tertiary.main
  },
  container: {
    maxHeight: theme.spacing(38.5)
  },
  status: {
    display: 'flex',
    alignItems: 'center'
  },
  statusText: {
    marginLeft: theme.spacing(0.5),
    padding: 0
  },
  emptyIcon: {
    minWidth: theme.spacing(2),
    minHeight: theme.spacing(2)
  },
  statusIcon: {
    width: theme.spacing(1.75),
    height: theme.spacing(1.62),
    borderRadius: '0px'
  },
  tableLoader: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  newLabelWrapper: {
    color: '#7A7A7C',
    pointerEvents: 'none',
    display: 'flex',
    maxWidth: 'initial',
    fontWeight: 'bold'
  },
  newLabel: {
    background: '#FF7141 0% 0% no-repeat padding-box',
    letterSpacing: 0,
    lineHeight: 0,
    color: theme.palette.secondary.main,
    textTransform: 'uppercase',
    height: theme.spacing(1.5),
    fontSize: 9,
    display: 'flex',
    fontWeight: 'bold',
    alignItems: 'center',
    borderRadius: theme.spacing(1),
    padding: theme.spacing(0, 0.5),
    marginLeft: theme.spacing(0.5)
  },
  expiry: {
    color: '#64AD00',
    fontSize: 12,
    fontWeight: 'bold'
  },
  leadStatusWrapper: {
    minWidth: theme.spacing(30)
  },
  inactiveBadge: {
    backgroundColor: theme.palette.primary.darkGray,
    color: theme.palette.primary.dark,
    borderRadius: theme.spacing(5),
    padding: theme.spacing(0.2, 0.8),
    fontSize: 9,
    position: 'relative',
    left: theme.spacing(0.8),
    bottom: theme.spacing(0.9)
  }
}));

const systemHeading = (isLead = false) => [
  {
    name: I18n.t('dashboard.nameId')
  },
  {
    name: I18n.t('dashboard.status')
  },
  {
    name: I18n.t('dashboard.city')
  },
  {
    name: isLead ? I18n.t('dashboard.leadSource') : I18n.t('dashboard.state')
  }
];

const SystemsTable = props => {
  const classes = useStyles();
  const {
    systemDetails = [],
    navigationUrl = '',
    isLead = false,
    isActivation = false,
    companyId,
    leadsLoading,
    openNewWindow = false,
    accountData
  } = props;
  const { envoyNotReporting, normalIcon, storage, micro } = Icons;
  const manager_token = getToken()

  const isSelfInstaller = get(accountData, 'self_installer', false)
  const enableNewActivationOnly = feature.isFeatureEnabled('ENABLE_NEW_ACTIVATION_ONLY')
  const isActivationenalbed = feature.isFeatureEnabled('ACTIVATION_WEB_FEATURE') || isSelfInstaller

  return (
    <Paper className={classes.root} variant="outlined" square>
      <TableContainer className={classes.container}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead className={classes.header}>
            <TableRow className={classes.tableRow}>
              {systemHeading(isLead).map((heading, index) => (
                <TableCell className={classes.headerText} key={index}>
                  {heading.name}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody className={classes.tableBody}>
            {systemDetails && systemDetails.length > 0 ? (
              <React.Fragment>
                {systemDetails.map((system, index) => {
                  if (system.id !== null) {
                    const url = isLead
                      ? getPlatformBasedUrl('dashboard.systemsTable.leadURL', {
                        companyId,
                        id: system.id,
                        journey_type: system.journey_type
                      })
                      : isActivation ? (isActivationenalbed && (accountData?.preferred_new_activation_view === null || accountData?.preferred_new_activation_view)) || enableNewActivationOnly ? settings.enlightenMenuUrl(`manager/dashboard/activations/${system.id}?fromEnlighten=${true}`) : settings.enlightenMenuUrl(`${navigationUrl}/${system.id}`) : settings.enlightenMenuUrl(`${navigationUrl}/${system.id}`)
                    // const status =
                    //   isLead || isActivation ? (
                    //     <Fragment />
                    //   ) : system.status === 'normal' ? (
                    //     <Normal className={classes.statusIcon} />
                    //   ) : (
                    //     <Warning className={classes.statusIcon} />
                    //   );
                    let updateStatus;
                    if (isLead || isActivation) {
                      updateStatus = <Fragment />;
                    } else {
                      if (system.status === 'normal') {
                        updateStatus = <Avatar alt="selected" src={normalIcon} className={classes.statusIcon} />;
                      } else if (system.status === 'comm') {
                        updateStatus = <Avatar alt="selected" src={envoyNotReporting} className={classes.statusIcon} />;
                      } else if (system.status === 'battery' || 'storage_idle') {
                        updateStatus = <Avatar alt="selected" src={storage} className={classes.statusIcon} />;
                      } else if (system.status === 'micro') {
                        updateStatus = <Avatar alt="selected" src={micro} className={classes.statusIcon} />;
                      } else {
                        updateStatus = <Warning className={classes.statusIcon} />;
                      }
                    }
                    const hasNewLabel = isLead && isEqual(get(system, 'status_id'), 1);
                    const isInActive = isLead && !get(system, 'is_active', true);
                    const stateOrSource = isLead ? system.lead_source || '-' : system.state || '-';
                    return (
                      <TableRow className={classes.tableRow} hover tabIndex={-1} key={index}>
                        <TableCell className={classes.tableCell}>
                          <Link
                            target={openNewWindow ? '_blank' : '_self'}
                            className={classes.linkTableCell}
                            href={url}
                          >
                            {system.name || '-'}
                            {isInActive && <span className={classes.inactiveBadge}>Inactive</span>}
                          </Link>
                        </TableCell>
                        <TableCell
                          className={clsx(
                            classes.statusTableCell,
                            classes.tableCell,
                            hasNewLabel && classes.leadStatusWrapper
                          )}
                        >
                          <Typography component="div" className={classes.status}>
                            {updateStatus}
                            {hasNewLabel ? (
                              <Tooltip title={system.status_text} arrow >
                                <Typography
                                  component="div"
                                  className={clsx(classes.statusText, classes.tableCell, classes.newLabelWrapper)}
                                >
                                  {system.status_text}
                                  <Typography className={classes.newLabel}>{I18n.t('dashboard.new')}</Typography>
                                  {!get(system, 'no_lead_expiry') &&
                                    get(system, 'expires_in') && (
                                      <Typography className={classes.expiry}>
                                        &nbsp;&nbsp;
                                        {getExpiryOfLead(get(system, 'expires_in'))}
                                      </Typography>
                                    )}
                                </Typography>
                              </Tooltip>
                            ) : (
                            <Tooltip title={system.status_text} arrow >
                              <Typography
                                component="div"
                                className={clsx(classes.statusTableCell, classes.statusText, classes.tableCell)}
                              >
                                {system.status_text}
                              </Typography>
                            </Tooltip>
                            )}
                          </Typography>
                        </TableCell>
                        <TableCell className={classes.tableCell}>{system.city || '-'}</TableCell>
                        <TableCell className={classes.tableCell}>{stateOrSource}</TableCell>
                      </TableRow>
                    );
                  } else {
                    return <React.Fragment />;
                  }
                })}
              </React.Fragment>
            ) : leadsLoading ? (
              <TableRow>
                <TableCell colSpan={systemHeading().length} style={{ textAlign: 'center', minHeight: '10vh' }}>
                  <Typography variant="caption">
                    <Loader loading={leadsLoading} small />
                  </Typography>
                </TableCell>
              </TableRow>
            ) : (
              <TableRow>
                <TableCell colSpan={systemHeading().length} style={{ textAlign: 'center' }}>
                  <Typography variant="caption">{`** ${I18n.t('dashboard.notAvailable')} **`}</Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default SystemsTable;
